/**
 * Created by rkamysz on 12/15/2014.
 */

export class FpsMeasurementResults {
    public minFps: number = 0;
    public averageFps: number = 0;
    public maxFps: number = 0;
}
